import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import pickupLocationAPI from '@infrastructure/pickup-location-api';
export const createPickupLocationAsync = createAsyncThunk('pickupLocation/create', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.createPickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePickupLocationAsync = createAsyncThunk('pickupLocation/update', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.updatePickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPickupLocationsAsync = createAsyncThunk('pickupLocation/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.getAllPickupLocations(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPickupLocationByIdAsync = createAsyncThunk('pickupLocation/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.getPickupLocationById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deletePickupLocationAsync = createAsyncThunk('pickupLocation/delete', async (id, { rejectWithValue }) => {
    try {
        await pickupLocationAPI.deletePickupLocation(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPickupLocationsNotPaginatedByEventIdAsync = createAsyncThunk('pickupLocation/getPickupLocationsNotPaginatedByEventId', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.getPickupLocationsNotPaginatedByEventId({
            ...request,
            includeClosed: request.includeClosed ?? false
        });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const ClosePickUpLocationAsync = createAsyncThunk('pickupLocation/closePickupLocation', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.closePickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const checkPickupLocationAvailabilityAsync = createAsyncThunk('pickupLocation/checkAvailability', async (payload, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.checkAvailability(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getTransportDashboardSummaryAsync = createAsyncThunk('pickupLocation/getTransportDashboardSummary', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.getTransportDashboardSummary(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getTransportDashboardTrendAsync = createAsyncThunk('pickupLocation/getTransportDashboardTrend', async (request, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.getTransportDashboardTrend(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getMapsKeyAsync = createAsyncThunk('pickupLocation/getMapsKey', async (_, { rejectWithValue }) => {
    try {
        const response = await pickupLocationAPI.getMapsKey();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
